import { ScreenHeadings } from "./types";

class OnboardingGetPropsFunctions {
    private controlBtnType: "Buttons" | "Arrow" | undefined;
    private design: number[][] | undefined;
    private Headers: ScreenHeadings[] | any;
    private loadingTracker: boolean | undefined;
    private multiChoice: "modal1" | "modal2" | undefined;
    private nextBtnText: string | undefined;
    private progress: string[] | undefined;
    private progressBarMultiLine: boolean | undefined;
    private showFooter: boolean | undefined;
    private singleChoose: "modal1" | "modal2" | "modal3" | undefined;
    private template: "multi-question" | "single-question" | "single-page" | undefined;

    constructor(
        controlBtnType: "Buttons" | "Arrow" | undefined,
        design: number[][] | undefined,
        Headers: ScreenHeadings[] | any,
        loadingTracker: boolean | undefined,
        multiChoice: "modal1" | "modal2" | undefined,
        nextBtnText: string | undefined,
        progress: string[] | undefined,
        progressBarMultiLine: boolean | undefined,
        showFooter: boolean | undefined,
        singleChoose: "modal1" | "modal2" | "modal3" | undefined,
        template: "multi-question" | "single-question" | "single-page" | undefined
    ) {
        this.controlBtnType = controlBtnType;
        this.design = design;
        this.Headers = Headers;
        this.loadingTracker = loadingTracker;
        this.multiChoice = multiChoice;
        this.nextBtnText = nextBtnText;
        this.progress = progress;
        this.progressBarMultiLine = progressBarMultiLine;
        this.showFooter = showFooter;
        this.singleChoose = singleChoose;
        this.template = template;
    }


    getControlBtnType(): "Buttons" | "Arrow" {
        return this.controlBtnType;
    }

    getDesign(): number[][] {
        return this.design;
    }

    getHeaders(): ScreenHeadings[] {
        return this.Headers;
    }

    getLoadingTracker(): boolean {
        return this.loadingTracker;
    }

    getMultiChoice(): "modal1" | "modal2" {
        return this.multiChoice;
    }

    getNextBtnText(): string {
        return this.nextBtnText;
    }

    getProgress(): string[] {
        return this.progress;
    }

    getProgressBarMultiLine(): boolean {
        return this.progressBarMultiLine;
    }

    getShowFooter(): boolean {
        return this.showFooter;
    }

    getSingleChoose(): "modal1" | "modal2" | "modal3" {
        return this.singleChoose;
    }

    getTemplate(): "multi-question" | "single-question" | "single-page" {
        return this.template;
    }
}

export default OnboardingGetPropsFunctions;